require('element-closest');

module.exports = require('./main');
